import { defineComponent, computed, openBlock, createElementBlock, createVNode, unref, createCommentVNode } from "vue";
import Notification03StrokeRoundedIcon from "../../assets/icons/outline/notification-03-stroke-rounded.svg.js";
const _hoisted_1 = {
  key: 0,
  class: "notification-bell__badge"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NotificationBell",
  props: {
    badgeCount: { default: 0 },
    showBadge: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const hasBadge = computed(() => props.showBadge && props.badgeCount > 0);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        class: "notification-bell",
        "aria-label": "Notifications",
        onClick: _cache[0] || (_cache[0] = ($event) => emit("click"))
      }, [
        createVNode(unref(Notification03StrokeRoundedIcon), { class: "notification-bell__icon" }),
        unref(hasBadge) ? (openBlock(), createElementBlock("span", _hoisted_1)) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=NotificationBell.vue2.js.map
